import React, { useEffect, useMemo, useState } from 'react'
import Navbar from '../../Navbar';
import { Button, Container, IconButton, ListItemIcon, MenuItem, Tooltip, Typography } from '@mui/material';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import MaterialReactTable from 'material-react-table';
import MarcarActivoUso from './activo/MarcarActivoUso';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { getData } from '../../../services/library';
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Delete } from "@mui/icons-material";
import BajaUsoEnvasado from './baja/BajaUsoEnvasado';
import EdicionUsoEnvasado from './edicion/EdicionUsoEnvasado';
import AltaUsoEnvasado from './alta/AltaUsoEnvasado';

function UsosEnvasado() {
  const [usos, setUsos] = useState(); //aca se almacenan los datos que me trae la api
    const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
    const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
    const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
    const [baja, setBaja] = useState(false); //Abre formulario
    const [dataUso, setDataUso] = useState({});
    const [marcarActivo, setMarcarActivo] = useState(false);
  
    //Tabla
    const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
    const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  
    //  Funcion para traer los clientes a la tabla : ACTIVOS
    const obtenerUsosInactivos = () => {
      setHiddenmuestrainactivo(true);
      setHiddenmuestraactivos(false);
      getData("/envasado_usos/inactivos", setUsos);
    };
  
    //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
    const obtenerUsos = () => {
      setHiddenmuestraactivos(true);
      setHiddenmuestrainactivo(false);
      getData("/envasado_usos/", setUsos);
    };
  
    useEffect(() => {
      obtenerUsos();
    }, [tabla]);
  
    const handleClickNuevo = () => {
      setAlta(true);
    };
  
    const handleCloseEditar = () => {
      setEditar(false);
      setTabla(true);
      obtenerUsos();
    };
    const handleCloseAlta = () => {
      setAlta(false);
      setTabla(true);
      obtenerUsos();
    };
  
    const columns = useMemo(
      () => [
        {
          accessorKey: "id", //access nested data with dot notation
          header: "ID",
          maxSize: 100,
        },
        {
          accessorKey: "uso", //access nested data with dot notation
          header: "Uso",
        },
      ],
      []
    );
  
    const muiSearchTextFieldProps = {
      placeholder: "Buscar..",
      sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
      variant: "outlined",
      color: "success",
      size: "small",
    };
  
    const initialState = {
      density: "compact",
      showGlobalFilter: true,
      pagination: { pageIndex: 0, pageSize: 10 },
    };
  
    const tableHeadCellProps = {
      align: "left",
      sx: {
        fontSize: 16,
        color: "white",
        fontWeight: "normal",
        backgroundColor: "#2471A3",
        borderColor: "black",
      },
    };
  
    const displayColumnDefOptions = {
      "mrt-row-actions": {
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
    };
  
    return (
      <>
        <Navbar />
        <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
          {tabla && (
            <MaterialReactTable
              localization={MRT_Localization_ES}
              columns={columns}
              data={usos ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false} //deshabilita las acciones POR COLUMNA
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableRowActions={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              displayColumnDefOptions={displayColumnDefOptions}
              enableColumnResizing={true}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
                sx: {
                  backgroundColor:
                    row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                  color: "black",
                },
              })}
              renderTopToolbarCustomActions={() => (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxTwoToneIcon color="asd" />}
                    onClick={handleClickNuevo}
                  >
                    Nuevo Uso
                  </Button>
                  <Typography variant="poster" fontSize={26}>
                    <PropaneTankIcon sx={{ fontSize: 20 }} />
                    Usos de Envasado
                  </Typography>
                </>
              )}
              renderToolbarInternalActions={() => (
                <>
                  {!hiddenmuestrainactivo ? (
                    <Tooltip title="Muestra Inactivos">
                      <IconButton
                        onClick={() => obtenerUsosInactivos()}
                        color="error"
                      >
                        <PersonOffIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {!hiddenmuestraactivos ? (
                    <Tooltip title="Mostrar ACTIVOS" color="success">
                      <IconButton onClick={() => obtenerUsos()}>
                        <PersonIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </>
              )}
              renderRowActionMenuItems={({ closeMenu, row, index }) => [
                <MenuItem
                  key={index}
                  style={{
                    display: row.original.activo === 0 ? null : "none",
                  }}
                  disabled={row.original.activo === 1}
                  onClick={() => {
                    setMarcarActivo(true);
                    setDataUso(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <CheckCircleOutlineIcon color="success" />
                  </ListItemIcon>
                  Marcar Activo
                </MenuItem>,
  
                <MenuItem
                  key={index}
                  style={{
                    display: row.original.activo === 0 ? "none" : null,
                  }}
                  disabled={row.original.activo === 0}
                  onClick={() => {
                    closeMenu();
                    setDataUso(row.original);
                    setEditar(true);
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <BorderColorIcon color="primary" />
                  </ListItemIcon>
                  Editar
                </MenuItem>,
  
                <MenuItem
                  key={index}
                  style={{
                    display: row.original.activo === 0 ? "none" : null,
                  }}
                  disabled={row.original.activo === 0}
                  onClick={() => {
                    closeMenu();
                    setDataUso(row.original);
                    setBaja(true);
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <Delete color="error" />
                  </ListItemIcon>
                  Marcar Inactivo
                </MenuItem>,
              ]}
            />
          )}
  
          {baja && (
            <BajaUsoEnvasado
              open={baja}
              setOpen={setBaja}
              uso={dataUso}
              tabla={setTabla}
              actualizar={obtenerUsos}
            />
          )}
          {editar ? (
            <EdicionUsoEnvasado
              editar={editar}
              datosRow={dataUso}
              onClose={() => handleCloseEditar(false)}
            />
          ) : null}
          {alta ? (
            <AltaUsoEnvasado alta={alta} onClose={() => handleCloseAlta(false)} />
          ) : null}
          {marcarActivo ? (
            <MarcarActivoUso
              open={marcarActivo}
              setOpen={setMarcarActivo}
              uso={dataUso}
              tabla={setTabla}
              actualizar={obtenerUsos}
            />
          ) : null}
        </Container>
      </>
    );
  }

export default UsosEnvasado